const SvgPlytaPelna60 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 60 60">
    <path fill="#373737" d="M34 58h16V14l-16 8zM32 20 2 5V2h26l20 10z" />
  </svg>;
export default SvgPlytaPelna60;